module.exports = __webpack_public_path__ + "static/media/waves.64b59544.png";